import { createContext } from 'react';
import { SearchAuthContextType } from 'context/Search/types';

// Define the context type to include searchConfig and index


// Initialize the context with both searchConfig and index
export const SearchAuthContext = createContext<SearchAuthContextType>({
  client: null,
  index: null,
  setRefetchCount: () => {console.log('setRefetchCount')},
});
